/**=========================================================
 * Module: main.js
 * Main Application Controller
 =========================================================*/

App.controller('AppController',
  ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'colors', 'browser', 'cfpLoadingBar','Restangular', 'toaster', 'Idle', 'Rollbar', 'DataService', '$filter', 'LocalRestangular', '$sce','ngDialog',
  function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, colors, browser, cfpLoadingBar, R, toaster, Idle, Rollbar, D, $filter, LR, $sce, ngDialog) {
    "use strict";

    var rootScopeEventListeners = [];

    $rootScope.isAppController = true
    $scope.$on('$destroy', function(){
      $rootScope.isAppController = false
    })

    $rootScope.dashboard = {}

    $rootScope.globalAlert = {};

    $scope.click = function($event){
      if(!$event.target.className || !$event.target.className.indexOf || $event.target.className.indexOf('dont-close-search')<0){
        $rootScope.$emit('$closeSearch');
      }
    }
    // Loading bar transition
    // -----------------------------------
    var thBar;
    rootScopeEventListeners.push($rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
      if($rootScope.preventStateChange){
        event.preventDefault()
        return
      }
        if($('.wrapper > section').length) // check if bar container exists
          thBar = $timeout(function() {
            cfpLoadingBar.start();
          }, 0); // sets a latency Threshold
        //$rootScope.$broadcast('$tooltipClose');
    }));
    
    $rootScope.currentPage = $state.current.name=='app.entity' ? $state.params.type + '.' + $state.params.action : $state.current.name;
    $rootScope.isSectionPage = $state.current.name.startsWith('section');
    rootScopeEventListeners.push($rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {
        event.targetScope.$watch("$viewContentLoaded", function () {
          $timeout.cancel(thBar);
          cfpLoadingBar.complete();
        });
        var url = toState.url;
        for(var key in toParams){
          url = url.replace(':'+key, toParams[key]);
        }
        $rootScope.gaUrl = url;
        if(!$rootScope.tooltips){
          $rootScope.tooltips = {};
        }
        $rootScope.currentPage = $state.current.name=='app.entity' ? $state.params.type + '.' + $state.params.action : $state.current.name;
        $rootScope.tooltips[$rootScope.currentPage] = [];
        $rootScope.tooltipsCounter[$rootScope.currentPage] = 0;
        if(!$rootScope.hasTooltips) $rootScope.hasTooltips = {};
        $rootScope.hasTooltips[$rootScope.currentPage] = null;
        $timeout(function(){$rootScope.$broadcast('$checkLogged');}, 900);
        if($state.current.name.startsWith('section')){
          $rootScope.isSectionPage = true;
        } else {
          $rootScope.isSectionPage = false;
        }
    }));

    // Hook not found
    rootScopeEventListeners.push($rootScope.$on('$stateNotFound',
      function(event, unfoundState, fromState, fromParams) {
          
      }));

    // Hook success
    rootScopeEventListeners.push($rootScope.$on('$stateChangeSuccess',
      function(event, toState, toParams, fromState, fromParams) {
        // display new view from top
        $window.scrollTo(0, 0);
        // Save the route title
        $rootScope.currTitle = $state.current.title;
      }));

    $rootScope.currTitle = $state.current.title;
    

    rootScopeEventListeners.push($scope.$on('IdleStart', function() {
      // the user appears to have gone idle
         //L.log('idlestart');
    }));
 
    rootScopeEventListeners.push($scope.$on('IdleWarn', function(e, countdown) {
      // follows after the IdleStart event, but includes a countdown until the user is considered timed out
      // the countdown arg is the number of seconds remaining until then.
      // you can change the title or display a warning dialog from here.
      // you can let them resume their session by calling Idle.watch()
         //L.log('idlewarn');
    }));
 
    rootScopeEventListeners.push($scope.$on('IdleTimeout', function() {
      // the user has timed out (meaning idleDuration + timeout has passed without any activity)
      // this is where you'd log them
         //L.log('idletimeout');
         //$scope.logout();
    }));
 
    rootScopeEventListeners.push($scope.$on('IdleEnd', function() {
      // the user has come back from AFK and is doing stuff. if you are warning them, you can use this to hide the dialog
         //L.log('idleend');
         checkLogged();
    }));
 
    rootScopeEventListeners.push($scope.$on('Keepalive', function() {
      // do something to keep the user's session alive
         //L.log('keepalive');
         //checkLogged();
    }));
 
    $rootScope.tooltips = {};
    $rootScope.tooltipsCounter = {};
    $rootScope.pulsating = {};
    rootScopeEventListeners.push($rootScope.$on('$tooltipOpen', function(event, args) {
      if(!$rootScope.tooltips[args.pid]) $rootScope.tooltips[args.pid] = {};
      if(!$rootScope.tooltips[args.pid][args.tid]){
        $rootScope.tooltips[args.pid][args.tid] = true;
        if(!$rootScope.tooltipsCounter[args.pid]) $rootScope.tooltipsCounter[args.pid] = 0;
        $rootScope.tooltipsCounter[args.pid]++;
        //L.log('tooltip open: ' + args.pid + ' ' + args.tid + ' ' + $rootScope.tooltipsCounter[args.pid]);
      }
    }));
    rootScopeEventListeners.push($rootScope.$on('$tooltipClose', function(event, args) {
      if(args.tid && $rootScope.tooltips[args.pid] && $rootScope.tooltips[args.pid][args.tid]){
        delete $rootScope.tooltips[args.pid][args.tid];
        $rootScope.tooltipsCounter[args.pid]--;
        if($rootScope.tooltipsCounter[args.pid]==0 && args.pid.indexOf('hover-')<0){
          D.load('tooltip', $rootScope.user.id + '_hover-general.reopentooltips')
            .then(function(res){
              if(res.id===null || res.id==='') {
                $rootScope.pulsating.reopenTooltips = true;
              }
            }).catch(console.error);
        }
        $rootScope.tooltipsCounter[args.pid] = Object.keys($rootScope.tooltips[args.pid]).length;
        //L.log('tooltip close: ' + args.pid + ' ' + args.tid + ' ' + $rootScope.tooltipsCounter[args.pid]);
      }
    }));

    $rootScope.toggleTooltips = function(pid){
      if($rootScope.tooltipsCounter[pid]>0){
        $rootScope.$broadcast('$tooltipClose', {pid: pid});
      } else {
        $rootScope.$broadcast('$tooltipOpenAll', { pid: pid });
      }
    }
    $rootScope.toogleHoverTooltips = function(pid, tid){
      if($rootScope.pulsating[tid]){
        $rootScope.toggleTooltips(pid); 
        $rootScope.pulsating[tid]=false;
      }
    }

    $rootScope.closeTooltipByEvent = function(pid, tid){
      $rootScope.$broadcast('$tooltipClose', { pid: pid, tid: tid, fromEvent: true});
    }

    $rootScope.updateTooltipsCounter = function(){
      $rootScope.tooltipsCounter['general'] = $rootScope.tooltips['general'] ? Object.keys($rootScope.tooltips['general']).length : 0;
      $rootScope.tooltipsCounter[$rootScope.currentPage] = $rootScope.tooltips[$rootScope.currentPage] ? Object.keys($rootScope.tooltips[$rootScope.currentPage]).length : 0;
    }
    // iPad may presents ghost click issues
    // if( ! browser.ipad )
      // FastClick.attach(document.body);

    // Close submenu when sidebar change from collapsed to normal
    $rootScope.$watch('app.layout.isCollapsed', function(newValue, oldValue) {
      if( newValue === false )
        $rootScope.$broadcast('closeSidebarMenu');
      $rootScope.$broadcast('$tooltipClose', { pid: 'general', tid: 'collapsemenu', fromEvent: true})
    });

    // Restore layout settings
    if( angular.isDefined($localStorage.layout) )
      $scope.app.layout = $localStorage.layout;
    else
      $localStorage.layout = $scope.app.layout;

    $rootScope.$watch("app.layout", function () {
      $localStorage.layout = $scope.app.layout;
    }, true);


    // Allows to use branding color with interpolation
    // {{ colorByName('primary') }}
    $scope.colorByName = colors.byName;

    // Hides/show user avatar on sidebar
    $scope.toggleUserBlock = function(){
      $scope.$broadcast('toggleUserBlock');
    };

    // Internationalization
    // ----------------------

    $scope.language = {
      // Handles language dropdown
      listIsOpen: false,
      // list of available languages
      available: {
        'en_GB':    'English',
        'it_IT':    'Italiano',
        'de_DE':	'German'
      },
      // display always the current ui language
      init: function () {
        var proposedLanguage = $translate.proposedLanguage() || $translate.use();
        var preferredLanguage = $translate.preferredLanguage(); // we know we have set a preferred one in app.config
        $scope.language.selected = $scope.language.available[ (proposedLanguage || preferredLanguage) ];
      },
      set: function (localeId, customKey) {
        // Set the new idiom
        $translate.use(localeId);
        $translate.setCustomTranslations(localeId, customKey)
        $window.moment.locale(localeId);
        // save a reference for the current language
        $scope.language.selected = $scope.language.available[localeId];
        // finally toggle dropdown
        $scope.language.listIsOpen = ! $scope.language.listIsOpen;

        if(localeId=='it_IT'){
        	$window.chosen_default_multiple_text = 'Seleziona una o più opzioni';
        	$window.chosen_default_single_text = 'Seleziona una opzione';
        	$window.chosen_default_no_result_text = 'Nessun risultato trovato';
        } else if(localeId=='de_DE'){
        	$window.chosen_default_multiple_text = 'Wählen Sie einige Optionen';
        	$window.chosen_default_single_text = 'Eine Option auswählen';
        	$window.chosen_default_no_result_text = 'Es wurde kein Ergebnis';
        } else {
        	$window.chosen_default_multiple_text = 'Select Some Options';
        	$window.chosen_default_single_text = 'Select an Option';
        	$window.chosen_default_no_result_text = 'No results match';
        }
        $rootScope.localeId = localeId;
      }
    };

    $scope.language.init();

    // Restore application classes state
    toggle.restoreState( $(document.body) );

    // Applies animation to main view for the next pages to load
    $timeout(function(){
      $rootScope.mainViewAnimation = $rootScope.app.viewAnimation;
    });

    var langCodeByLang = {};
    var langByLangCode = {};
    //load languages
    R.all('language').getList().then(function(response){
        for(var i=0; i<response.length; i++){
          response[i].name = $filter('translate')('enums.language.'+response[i].code).toLowerCase();
          langCodeByLang[response[i].code] = response[i].mq;
          langByLangCode[response[i].mq] = response[i].code;
        }
        response.sort(function(a,b){
          return a.name > b.name ? 1 : -1;
        });
        $rootScope.languages = response;
    });

    $rootScope.mqLanguageCode = function(code){
        if(Array.isArray(code)){
            var newAr = [];
            for(var i=0; i<code.length; i++){
                newAr.push(langCodeByLang[code[i]]);
            }
            return newAr;
        } else {
            return langCodeByLang[code.replace('-','_')];
        }
    }
    $rootScope.aqLanguageCode = function(code){
      if(Array.isArray(code)){
          var newAr = [];
          for(var i=0; i<code.length; i++){
              newAr.push(langByLangCode[code[i]]);
          }
          return newAr;
      } else {
          return langByLangCode[code];
      }
    }

    let checkFS = function(){
      let t1 = new Date().getTime();

      let checkOnSn = function(e){
        let t2 = new Date().getTime();
        e.t = t2 - t1
        FIREBASE.read(['rt', 'check'], function(data){
          if(!data || !data.value){
            notify(e, {code: data, name: 'NoData'}, t2)
          }
        }, function(err){
          notify(e, err || {code: undefined, name: 'ErrorUndefined'}, t2)
        }, 
        { noWorkaround:true })
      }

      let notify = function(e1, e2, t2){
        let t3 = new Date().getTime();
        e2.t = t3 - t2
        let _navigator = {};
        for (let i in window.navigator) _navigator[i] = window.navigator[i];
        R.one('account','me').customPUT({action:'NotifyCheck',error:e1, error2: e2,data:_navigator})
      }

      FIREBASE.get('rt', 'check', function(data){
        if(!data || !data.value){
          checkOnSn({code: data, name: 'NoData'})
        }
      }, function(err){
        checkOnSn(err)
      })
    }

    //check user logged
    //if not go to login
    var stateParams = {goTo: $state.current.name};
    if($state.params) stateParams.params = angular.toJson($state.params);
    $rootScope.loadCurrentUser = function(){
      R.one('account','me').get().then(
          function(account){
              if(!account.id || !account.active){
                  $rootScope.$broadcast('$userLoggedOut');
                  //$state.go('page.login', stateParams);
              } else {
                  $rootScope.user = account;
                  $scope.language.set(account.language, account.group.id);
                  $rootScope.$broadcast('$userLoggedOn');
                  $window.userDateFormat = account.dateFormat;

                  checkFS();
              }
          },
          function(){
              $rootScope.$broadcast('$userLoggedOut');
              //$state.go('page.login', stateParams);
          }
      );
    }


    FIREBASE.checkAuth(function(){
      $rootScope.loadCurrentUser();
    }, function(){
      $rootScope.$broadcast('$userLoggedOut')
    })

    var showGlobalAlert = function(msg, cls){
      $rootScope.globalAlert.msg = msg;
      $rootScope.globalAlert.cls = cls || 'warning';
      $rootScope.globalAlert.show = true;
    }
    var dismissGlobalAlert = function(){
      $rootScope.globalAlert.show = false;
    }

    $rootScope.rebootLocalServer = function(){
      LR.oneUrl('server').customDELETE('')
        .catch(function(){
          document.getElementById('LaunchLocalServer').click()
        })
    }
    $rootScope.stopLocalServer = function(){
      LR.oneUrl('server').customDELETE('').catch(console.error)
      $timeout(function(){$rootScope.checkWS()}, 1000)
    }
    
    $rootScope.checkWS = function(){
      if($rootScope.user.admin){
        $rootScope.localServer = {};
        LR.oneUrl('server').customGET('').then(function(r){
          if(r && r.online){
            $rootScope.localServer = r;
            if(r.version!=r.latest && r.latest){
              //$rootScope.addMessage('localversion', { version: r.latest })
              $rootScope.localServer.outdated = true
            }
            $rootScope.localServer.cls = ''
            $rootScope.localServer.iconClasses = 'ri-checkbox-blank-circle-fill text-success'
          } else {
            $rootScope.localServer = { version: 'Offline' };
            $rootScope.localServer.cls = 'text-warning shake-top'
            $rootScope.localServer.iconClasses = 'ri-checkbox-blank-circle-fill text-warning'
          }
        }).catch(function(e){
          $rootScope.localServer = { version: 'Offline' };
          $rootScope.localServer.cls = 'text-warning shake-top'
          $rootScope.localServer.iconClasses = 'ri-checkbox-blank-circle-fill text-danger'

        })
      }
    }

    let checkLoggedTimer = null
    var checkLogged = function(retries){
      if($rootScope.user.id ){
        FIREBASE.getToken(true).then(function(token){
          R.one('account','me').get().then(
                  function(account){
                      if(!account.id || !account.active){
                          $rootScope.$broadcast('$userLoggedOut');
                      } else {
                        account.loggedOn = true;
                        if($rootScope.user.group && account.group && $rootScope.user.group.id!=account.group.id && account.sgUser){
                          $rootScope.$broadcast('$notify', {msg: $filter('translate')('labels.SUPERGROUPCHANGE', {groupName: account.group.name})})
                        }
                        $rootScope.user = account;
                        $rootScope.user.group = account.group;
                        if(!account.opts.gdprcheck){
                          $state.go('page.privacy', angular.fromJson($state.params.params));
                        }

                      }
                      $rootScope.checkWS();
                  }
              );
          }).catch(function(){
            if(retries>4){
              $rootScope.$broadcast('$userLoggedOut');
            } else {
              $timeout(function(){checkLogged(retries+1)}, 30000)
            }
          })
        /*R.one('session','mine').customPUT({}).then(function(session){
          FIREBASE.auth(session.jwt, null)
        })*/
        if(!retries){
          $timeout.cancel(checkLoggedTimer)
          checkLoggedTimer = $timeout(checkLogged, 12 * 60 * 1000);
        }
      }
      
    };
    //$timeout(checkLogged, 10000);

    rootScopeEventListeners.push($rootScope.$on('$checkLogged', function(event){ 
      checkLogged();
    }));

    

    $window._aqrate_user = null;
    rootScopeEventListeners.push($rootScope.$on('$userLoggedOn', function(){
        $rootScope.user.loggedOn = true;
        $window._aqrate_user = $rootScope.user;
        if($rootScope.user.imp){
          $('body').addClass('imp');
        } else {
          $('body').removeClass('imp');
        }
        if($rootScope.user.sgUser){
          D.query('group', '_sgUser=' + $rootScope.user.id, { cache: false }).then(function(response){
            response.sort(function(a, b){ return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1; })
            $rootScope.usergroups = response;
            $rootScope.$broadcast('$load:usergroups')
          }).catch(console.error)
        }
        if($rootScope.user.groupType=='SUPPLIER'){
          D.query('group', 'type=CLIENT', { cache: false }).then(function(response){
            $rootScope.clients = response.sort((a,b)=>a.name.toLowerCase()>b.name.toLowerCase()?1:-1);
            $rootScope.$broadcast('$load:clients')
          })
        }
        if($rootScope.user.groupType=='CLIENT'){
          D.query('reference','client='+$rootScope.user.group.id, { cache: false }).then(function(response){
            $rootScope.suppliers = response.map(s=>{ return {id:s.supplier, name:s.supplierName} }).sort((a,b)=>a.name.toLowerCase()>b.name.toLowerCase()?1:-1);
            $rootScope.$broadcast('$load:suppliers')
          })
        }
        if($rootScope.user.groupType=='CLIENT' && $rootScope.user.superUser){
          D.query('account', 'group='+$rootScope.user.group.id, { cache: false }).then(function(response){
            $rootScope.owners = response.sort((a,b)=>a.name.toLowerCase()>b.name.toLowerCase()?1:-1);
            $rootScope.$broadcast('$load:owners')
          })
        }
        if($rootScope.user.groupType=='ADMIN'){
          D.query('group', 'type=CLIENT', { cache: false }).then(function(response){
            $rootScope.clients = response.sort((a,b)=>a.name.toLowerCase()>b.name.toLowerCase()?1:-1);
            $rootScope.$broadcast('$load:clients')
          })
          D.query('group', 'type=SUPPLIER', { cache: false }).then(function(response){
            $rootScope.suppliers = response.sort((a,b)=>a.name.toLowerCase()>b.name.toLowerCase()?1:-1);
            $rootScope.$broadcast('$load:suppliers')
          })
          D.query('account','grouptype=admin', { cache: false }).then(function(response){
            $rootScope.admins = response.sort((a,b)=>a.name.toLowerCase()>b.name.toLowerCase()?1:-1);
            $rootScope.$broadcast('$load:admins')
          })
          D.query('account', 'grouptype=client', { cache: false }).then(function(response){
            $rootScope.owners = response.sort((a,b)=>a.name.toLowerCase()>b.name.toLowerCase()?1:-1);
            $rootScope.$broadcast('$load:owners')
          })
        }
        
        $rootScope.updateFirebaseListeners();
        if(Rollbar && Rollbar.Rollbar) Rollbar.configure({
          payload: {
            person: {
              id: $rootScope.user.id, // required 
              username: $rootScope.user.username,
              email: $rootScope.user.email
            }
          }
        });
        $rootScope.checkWS();
    }));
    rootScopeEventListeners.push($rootScope.$on('$userLoggedOut', function(){
        $rootScope.user.loggedOn = false;
        FIREBASE.auth(false)
        $state.go('page.login', stateParams);
        if(Rollbar && Rollbar.Rollbar) Rollbar.configure({
          payload: {
            person: {
              id: 0, // required 
              username: '',
              email: ''
            }
          }
        });
    }));

    $scope.loggingOut = false;
    $scope.logout = function(){
    	$scope.loggingOut = true;
    	angular.element('#logoutSpinner').css('visibility','visible');
        R.one('session', 'mine').remove().then(
            function(s){
              FIREBASE.auth(s.jwt, function(){
                $('body').removeClass('imp');
                if(s.account){
                  $window.location.reload();
                } else {
                  stateParams = {};
                  $rootScope.$broadcast('$userLoggedOut');
                  $scope.loggingOut = false;
                  angular.element('#logoutSpinner').css('visibility','hidden');
                }
              })
            }
        );
    };

    $scope.addLogin = function(){
      let newScope = $scope.$new(true)
      newScope.add = true
      ngDialog.open({
        template: 'app/views/partials/addlogin.html',
        controller: 'LoginController',
        className: 'ngdialog-theme-default',
        scope: newScope
      })
    }

    $scope.changeSession = function(userId){
        R.one('session', 'mine').customPUT({action:'ChangeSession',userId:userId}).then(function(response){
          FIREBASE.auth(response.jwt, function(){
            $window.location.reload();
          })
        })
    }

    $scope.setTempGroup = function(gid){
      $rootScope.user.tempGroup = gid;
      $rootScope.user.action = 'SetTempGroup';
      D.save('account', $rootScope.user).then(function(response){
        var params = $state.params;
        params.name = $state.current.name;
        $state.go('app.entity', {
          action: 'ongoing',
          type: 'transition',
          filter: angular.toJson(params)});
      }).catch(console.error);
      $rootScope.user.action = null;
    }

    $scope.notify = function(msg){
      $rootScope.notifyMessage = msg;
      $timeout(function(){
        angular.element('#NotifyButton').click();
      }, 500);
    }
    
    rootScopeEventListeners.push($rootScope.$on('$notify', function(event, data){
      $scope.notify(data.msg);
    }));

    $rootScope.files = {};
    rootScopeEventListeners.push($rootScope.$on('$refreshFile', function(event, data){
    	if(data.deleted){
    		delete $rootScope.files[data.type+data.entityId+data.field];
    	} else {
    		$rootScope.files[data.type+data.entityId+data.field] = data.files;
    	}
    	if(data.form && data.form.refreshFile){
    		data.form.refreshFile(data);
    	}
    }));

    $scope.safeApply = function(fn) {
    	  var phase = this.$root.$$phase;
    	  if(phase == '$apply' || phase == '$digest') {
    	    if(fn && (typeof(fn) === 'function')) {
    	      fn();
    	    }
    	  } else {
    	    this.$apply(fn);
    	  }
    	};

    $rootScope.generateUUID = function(noDash, prefix) {
    	if(!prefix) prefix = '';
        var d = new Date().getTime();
        var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = (d + Math.random()*16)%16 | 0;
            d = Math.floor(d/16);
            return (c=='x' ? r : (r&0x3|0x8)).toString(16);
        });
        return prefix + (noDash ? uuid.replace(/-/g,'') : uuid);
    };

    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");

    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))      // If Internet Explorer, return version number
        $rootScope.IE = true;
    else                 // If another browser, return 0
        $rootScope.IE = false;

    if (/Edge\/\d./i.test(navigator.userAgent)){
        $rootScope.IE = true;
    }

    for(var i=0; i<rootScopeEventListeners.length; i++){
      $scope.$on('$destroy', rootScopeEventListeners[i]);
    }

    $rootScope.timeZone = parseInt(moment().format('ZZ'))/100;

    

}]);
